export const reportingVariables = [
	{
		type: "from_date",
		description: "From date for the reporting process.",
		field: "calendar",
	},
	{
		type: "to_date",
		description: "To date for the reporting process.",
		field: "calendar",
	},
	{
		type: "project_id",
		description: "Project ID for the reporting process.",
		field: "autocomplate",
	},
	{
		type: "employee_id",
		description: "Employee ID for the reporting process.",
		field: "autocomplate",
	},
];
